import React, { useEffect, useContext } from 'react'
import { MyContext } from '@/store/myContext'
import { useHomeMapModel } from './homeMapModel'
import { useHomeSoketModel } from './homeSoket'
import { Switch } from 'antd'
import { Maximize2, Minimize2 } from 'lucide-react'
import VehicleList from './vehicleList'
import './index.less'
import Popup from './popup'
import { useHomePengddingOrderModel } from './homePengddingOrder'
import RepairConnections from './RepairConnections.jsx'

export default () => {
    const { state } = useContext(MyContext)
    const {
        showFull,
        setShowFull,
        handleAutoRefresh,
        initMap,
        getVehicles,
        vehicleList,
        markers,
        updateMakers,
        mapCenter,
        mapRef,
        mapInstance,
        destroyMap,
        openVehicleWindowInfo,
        pengdingOrderMarkers,
        updatePengdingOrderMarkers,
    } = useHomeMapModel()
    const { createWebSocket } = useHomeSoketModel()
    const { penddingOrders, isHasPengddingOrderProce, getOrderDetail } = useHomePengddingOrderModel()

    //默认加载待工接单 和进度提醒数据
    useEffect(() => {
        if (state.activeMenu !== 'homeIndex') return
        let timer
        const start = () => {
            if (window.TMap && document.getElementById('map-box')) {
                initMap()
                getVehicles()
            } else {
                timer = setTimeout(start, 100)
            }
        }
        start()
        return () => {
            clearTimeout(timer)
            destroyMap()
        }
        // 地图只随首页进入/退出创建销毁，其他全局状态变化不重建地图。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.activeMenu])

    useEffect(() => {
        //有订单未处理 && 没有未处理完成的订单
        if (!isHasPengddingOrderProce && penddingOrders.length > 0) {
            //延迟弹出出现
            setTimeout(() => {
                getOrderDetail(penddingOrders[0])
            }, 5000);
        }
    }, [penddingOrders, isHasPengddingOrderProce])

    //初始化ws
    useEffect(() => {
        createWebSocket()
    }, [])

    //更新marker
    useEffect(() => {
        if (state.activeMenu === 'homeIndex' && mapInstance) {
            updateMakers(markers)
        }
    }, [markers, mapInstance])

    //更新订单marker
    useEffect(() => {
        if (state.activeMenu === 'homeIndex' && mapInstance) {
            updatePengdingOrderMarkers(pengdingOrderMarkers)
        }
    }, [pengdingOrderMarkers, mapInstance])

    useEffect(() => {
        const { longitude, latitude } = mapCenter
        if (longitude && latitude && mapRef.current && mapRef.current.setCenter) {
            mapRef.current.setCenter(new window.TMap.LatLng(latitude, longitude))
        }
    }, [mapCenter])

    return (
        <>
            {state.activeMenu === 'homeIndex' && (
                <>
                    <div className={`home-container ${showFull ? 'full-screen' : ''} `}>
                        <button
                            className="full-screen-btn"
                            aria-label={showFull ? '退出地图全屏' : '地图全屏'}
                            onClick={() => {
                                setShowFull(!showFull)
                            }}
                        >
                            {showFull ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
                        </button>
                        <div id="map-box" style={{ width: '100%', height: '100%' }}></div>
                        <RepairConnections map={mapInstance} />
                        <div className="home-top-box">
                            <div className="top-left-box">
                                <Switch
                                    className="switch"
                                    onChange={handleAutoRefresh}
                                    checkedChildren="开启自动刷新"
                                    unCheckedChildren="关闭自动刷新"
                                    size="default"
                                />
                                <VehicleList vehicleList={vehicleList} openVehicleWindowInfo={openVehicleWindowInfo} />
                            </div>
                        </div>
                    </div>
                    <Popup />
                </>
            )}
        </>
    )
}
